export default {
  nav: {
    howItWorks: 'How it works',
    signIn: 'Sign in',
    startFree: 'Contact us →',
  },

  hero: {
    badge: 'Built for gym owners',
    title1: 'The all-in-one platform',
    title2: 'for gym owners',
    desc: 'Manage your members, subscriptions, classes, trainers, check-ins and revenue — from a single dashboard. No more spreadsheets or paper receipts.',
    cta: 'Contact us →',
    ctaSub: 'See how it works',
    fine: 'Personalized demo · Guided onboarding',
  },

  howItWorks: {
    eyebrow: 'Simple setup',
    title: 'Up and running in under 10 minutes',
    steps: [
      { num: '01', title: 'Talk to our team', desc: 'We set up your gym profile for you: name, contact info and preferences. No technical setup on your end.' },
      { num: '02', title: 'Configure your plans', desc: 'Set up your membership plans with pricing, duration, and included features. Define your class schedule and trainer roster.' },
      { num: '03', title: 'Add your members', desc: 'Import existing members or add them one by one. Each member gets a unique QR code for check-in.' },
      { num: '04', title: 'Run your gym', desc: 'Manage daily check-ins, track renewals, book PT sessions, handle payments — all from one dashboard.' },
    ],
    ctaTitle: 'Ready to modernize your gym?',
    ctaDesc: 'Join the gyms already using UbiGym to grow their business.',
    ctaBtn: 'Contact us →',
  },

  footer: {
    desc: 'The all-in-one gym management platform for modern gym owners.',
    email: 'contact@ubigym.ma',
    product: 'Product',
    account: 'Account',
    legal: 'Legal',
    links: {
      howItWorks: 'How it works',
      signIn: 'Sign in',
      contact: 'Contact us',
      privacy: 'Privacy policy',
      terms: 'Terms of service',
      cookies: 'Cookie policy',
    },
    rights: 'All rights reserved.',
    madeFor: 'Made for gym owners 🏋️',
  },
}
